let News = [
    {
        "id":1,
        "title":"Forests",
        "image":"https://picsum.photos/300/250",
        "url":"#",
        "date":"01.04.2023",
        "vote":0,
        "see":1,
        "info":"Lorem ipsum dolor sit amet consectetur adipisicing elit. Est amet corporis id sed? Eos aut mollitia ipsam quisquam repellendus neque."
    },
    {
        "id":2,
        "title":"Forests",
        "image":"https://picsum.photos/300/250",
        "url":"#",
        "date":"01.04.2023",
        "vote":0,
        "see":1,
        "info":"Lorem ipsum dolor sit amet consectetur adipisicing elit. Est amet corporis id sed? Eos aut mollitia ipsam quisquam repellendus neque."
    },
    {
        "id":3,
        "title":"Forests",
        "image":"https://picsum.photos/300/250",
        "url":"#",
        "date":"01.04.2023",
        "vote":0,
        "see":1,
        "info":"Lorem ipsum dolor sit amet consectetur adipisicing elit. Est amet corporis id sed? Eos aut mollitia ipsam quisquam repellendus neque."
    },
    {
        "id":4,
        "title":"Forests",
        "image":"https://picsum.photos/300/250",
        "url":"#",
        "date":"01.04.2023",
        "vote":0,
        "see":1,
        "info":"Lorem ipsum dolor sit amet consectetur adipisicing elit. Est amet corporis id sed? Eos aut mollitia ipsam quisquam repellendus neque."
    },
]

export default News